// extracted by mini-css-extract-plugin
export default {"container":"style_container__GPAXF","column":"style_column__YNJz5"};